module.exports = __webpack_public_path__ + "svg/flags/Virgin Islands, U.S..svg";